// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3CxNT","title":"ClientCherryInfo_title__2L_hT","itemText":"ClientCherryInfo_itemText__3wHib"};